// extracted by mini-css-extract-plugin
export default {"form":"form---yDkVU","footer":"footer---K4wka"};